<div class="row">
  <div class="col-12">
    <div class="card mt-3">
      <div class="card-header">
        <div class="row align-items-center justify-content-between">
          <div class="col-4 col-sm-auto d-flex align-items-center pr-0">
            <h5 class="fs-0 mb-0 text-nowrap py-2 py-xl-0">Statuses</h5>
          </div>
          <div class="col-8 col-sm-auto ml-auto text-right pl-0">


            <div id="divSearchFilter" class="d-inline-block position-relative mr-2" (click)="searchInputOperation()">
              <input type="search" id="inputSearchFilter" class="form-control form-control-sm" [(ngModel)]="searchStatus"
                     (keyup)="getSearchData(searchStatus)" (input)="getSearchData(searchStatus)"
                     placeholder="Search..." autocomplete="off" appTrimLeft />
            </div>

            <button class="btn btn-sm btn-danger" [hidden]="_pluginservice.checkedList?.length==0"
                    data-toggle="modal" type="button" (click)="modalDelete(0,'','',['statusStatus'])">
              <span class="fas fa-trash-alt d-inline-block d-sm-none"
                    data-fa-transform="shrink-3 down-2"></span>
              <span class="d-none d-sm-inline-block">
                Delete
              </span>
            </button>
            <button class="btn btn-success rounded btn-sm" type="button" [hidden]="_pluginservice.checkedList?.length!=0" (click)="editStatus(0)">
              <span class="fas fa-plus d-inline-block d-sm-none"
                    data-fa-transform="shrink-3 down-2"></span>
              <span class="d-none d-sm-inline-block">
                Create new
              </span>
            </button>
          </div>
        </div>
      </div>
      <div class="card-body bg-light p-0">
        <div [style.opacity]="loading ? '0' : '1'">
          <div class="card-body p-0 card-scroll" (scroll)="onScrollData($event)">
            <div class="falcon-data-table">
              <div class="falcon-data-table table-responsive">
                <table class="table table-sm mb-0 table-striped border-bottom">
                  <thead class="bg-200 text-900 sticky-header">
                    <tr>
                      <th class="pr-1 align-middle w-30px">
                        <div class="custom-control custom-checkbox">
                          <input class="custom-control-input checkbox-bulk-select"
                                 id="statusBulk" type="checkbox"
                                 [(ngModel)]="_pluginservice.masterSelected"
                                 (change)="_pluginservice.checkAll(status,'statusBulk')"
                                 [disabled]="status?.length==0"
                                 [attr.checked]="_pluginservice.checkedList.length==status?.length ? 'checked' : null"
                                 [attr.indeterminate]="(_pluginservice.checkedList.length>0) && _pluginservice.checkedList.length!=status?.length ? 'indeterminate' : false"
                                 [indeterminate]="(_pluginservice.checkedList.length>0) && _pluginservice.checkedList.length!=status?.length ? 'indeterminate' : false" />
                          <label class="custom-control-label" for="statusBulk"></label>
                        </div>
                      </th>
                      <th class="pr-1 align-middle cursor-pointer text-left" (click)="sortType = 'name'; sortReverse = !sortReverse;sortData('name');">
                        Name
                        <span *ngIf="sortType == 'name' && !sortReverse">
                          <i class="fas fa-sort-up"></i>
                        </span>
                        <span *ngIf="sortType == 'name' && sortReverse">
                          <i class="fas fa-sort-down"></i>
                        </span>
                      </th>
                      <th class="pr-1 align-middle cursor-pointer text-left" (click)="sortType = 'type'; sortReverse = !sortReverse;sortData('type');">
                        Type
                        <span *ngIf="sortType == 'type' && !sortReverse">
                          <i class="fas fa-sort-up"></i>
                        </span>
                        <span *ngIf="sortType == 'type' && sortReverse">
                          <i class="fas fa-sort-down"></i>
                        </span>
                      </th>
                      <th class="pr-1 align-middle cursor-pointer text-left min-w-400px" (click)="sortType = 'desc'; sortReverse = !sortReverse;sortData('desc');">
                        Description
                        <span *ngIf="sortType == 'desc' && !sortReverse">
                          <i class="fas fa-sort-up"></i>
                        </span>
                        <span *ngIf="sortType == 'desc' && sortReverse">
                          <i class="fas fa-sort-down"></i>
                        </span>
                      </th>
                      <th class="pr-1 align-middle cursor-pointer text-left min-w-30px" (click)="sortType = 'order'; sortReverse = !sortReverse;sortData('order');">
                        Order
                        <span *ngIf="sortType == 'order' && !sortReverse">
                          <i class="fas fa-sort-up"></i>
                        </span>
                        <span *ngIf="sortType == 'order' && sortReverse">
                          <i class="fas fa-sort-down"></i>
                        </span>
                      </th>
                      <th class="pr-1 align-middle cursor-pointer text-left min-w-30px" (click)="sortType = 'color'; sortReverse = !sortReverse;sortData('color');">
                        Color
                        <span *ngIf="sortType == 'color' && !sortReverse">
                          <i class="fas fa-sort-up"></i>
                        </span>
                        <span *ngIf="sortType == 'color' && sortReverse">
                          <i class="fas fa-sort-down"></i>
                        </span>
                      </th>
                      <th class="pr-1 align-middle cursor-pointer text-left" (click)="sortType = 'status'; sortReverse = !sortReverse;sortData('status');">
                        Status
                        <span *ngIf="sortType == 'status' && !sortReverse">
                          <i class="fas fa-sort-up"></i>
                        </span>
                        <span *ngIf="sortType == 'status' && sortReverse">
                          <i class="fas fa-sort-down"></i>
                        </span>
                      </th>
                      <th class="pr-1 align-middle">
                      </th>
                    </tr>
                  </thead>
                  <tbody id="statusBody">
                    <tr class="btn-reveal-trigger" *ngFor="let ld of status">
                      <td class="align-middle">
                        <div class="custom-control custom-checkbox" *ngIf="!ld.reserved">
                          <input class="custom-control-input checkbox-bulk-select-target" type="checkbox" id="ld{{ld.id}}"
                                 [(ngModel)]="ld.checkboxOpe"
                                 (change)="_pluginservice.isAllSelected(status);getCheckedId(ld.id)" />
                          <label class="custom-control-label" for="ld{{ld.id}}"></label>
                        </div>
                      </td>
                      <th class="align-middle text-left">
                        <a href="javascript:void(0)" (click)="editStatus(ld.id)">
                          {{ld.name}}
                        </a>
                      </th>
                      <td class="align-middle text-left">
                        {{ld.type}}
                      </td>
                      <td class="align-middle text-left">
                        {{ld.desc}}
                      </td>
                      <td class="align-middle text-left">
                        {{ld.order}}
                      </td>
                      <td class="align-middle text-left">
                        {{ld.color}}
                      </td>
                      <td class="align-middle text-left">
                        <div class="custom-control custom-switch">
                          <input class="custom-control-input" type="checkbox" id="statusSwitch{{ld.id}}" [(ngModel)]="ld.status" (change)="changeStatus('status', ld.id, ld.status,'changeStatus')" />
                          <label class="custom-control-label cursor-pointer" for="statusSwitch{{ld.id}}"></label>
                        </div>
                      </td>
                      <td class="align-middle white-space-nowrap">
                        <div class="dropdown text-sans-serif" id="threeNo{{ld.id}}">
                          <button class="btn btn-link text-600 btn-sm dropdown-toggle btn-reveal mr-3"
                                  type="button" id="dropdown0"
                                  data-toggle="dropdown"
                                  data-boundary="html"
                                  aria-haspopup="true"
                                  aria-expanded="false">
                            <span class="fas fa-ellipsis-h fs--1"></span>
                          </button>
                          <div class="dropdown-menu dropdown-menu-right border py-0"
                               aria-labelledby="dropdown0">
                            <div class="bg-white py-2">
                              <a class="dropdown-item cursor-pointer" (click)="editStatus(ld.id)">Edit</a>
                              <div class="dropdown-divider" *ngIf="!ld.reserved"></div>
                              <a class="dropdown-item text-danger" *ngIf="!ld.reserved" href="javascript:void(0)" (click)="modalDelete(ld.id,'status','delete',[])">Delete</a>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody class="text-center w-100 py-3 bg-light" *ngIf="status?.length == 0">
                    <tr>
                      <td colspan="10" class="px-2 py-3 bg-light text-center w-100">
                        <p class="text-center bold-text font-size18px m-0">No data available</p>
                        <p class="text-center m-0 text-gray font-size13px">There is nothing to show you right now</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <ngx-loading [show]="loading"></ngx-loading>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Modal Status-->
<div class="modal fade" id="statusModal" tabindex="-1" role="dialog" aria-labelledby="statusModal" data-backdrop="static" data-keyboard="false"
     aria-hidden="true" (keydown.esc)="modalStatusClose()">
  <div class="modal-dialog activity-select-modal-width" role="document">
    <div class="modal-content ">
      <div class="modal-header">
        <h5 class="modal-title">{{modalTitle}}</h5>
        <button class="close" type="button" aria-label="Close" (click)="modalStatusClose()">
          <span class="font-weight-light" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body modal-padding" name="statusModalModal" id="statusModalBody">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="name">Name <span class="text-danger">*</span></label>
              <input class="form-control form-control-sm" id="name" type="text" title="name" name="title" [(ngModel)]="statusObj.name" required="required" appTrimLeft autocomplete="off" tabindex="1" />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label for="type">Type <span class="text-danger">*</span></label>
              <select [(ngModel)]="statusObj.type" id="type" title="type" class="form-control form-control-sm" required (ngModelChange)="changeType()" tabindex="2">
                <option value="">Choose</option>
                <option *ngFor="let t of statusObj.typeList" value="{{t.id}}">{{t.name}}</option>
              </select>
            </div>
          </div>
          <div class="col-12" *ngIf="statusObj.statusTitle?.length>0">
            <p class="mt-1 fs-14">Description: {{statusObj.statusTitle}}</p>
          </div>
          <div class="col-sm-6 col-12">
            <div class="form-group">
              <label for="color">Color</label>
              <input class="form-control form-control-sm" id="color" type="text" title="color" name="color" [(ngModel)]="statusObj.color" appTrimLeft autocomplete="off" tabindex="3" />
            </div>
          </div>
          <div class="col-sm-6 col-12">
            <div class="form-group">
              <label for="order">Order</label>
              <input class="form-control form-control-sm" id="order" appNumbersOnly appSelectedInput title="order" name="order" [(ngModel)]="statusObj.order" tabindex="6">
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label for="desc">Description</label>
              <textarea class="form-control form-control-sm" id="desc" rows="3" [(ngModel)]="statusObj.desc" appTrimLeft autocomplete="off" maxLength="250" tabindex="7"></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-falcon-default btn-sm" type="button" (click)="modalStatusClose()">Close</button>
        <button class="btn btn-primary btn-sm" id="btnstatus" type="button" [disabled]="!statusObj.name || !statusObj.type" (click)="saveStatus()">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Modal Delete-->
<div class="modal fade z-index10001 pr-0" style="padding-right:0!important" id="modalDelete" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
     data-backdrop="static" data-keyboard="false" aria-hidden="true" (keydown.esc)="modalDeleteClose()">
  <div class="modal-dialog modal-dialog-center modal-delete-width" role="document">
    <div class="modal-content">
      <div class="modal-header" style="border-bottom: none">
        <div class="modal-delete-header-icondiv">
          <i class="far fa-times-circle text-center modal-delete-circle-icon"></i>
        </div>
        <button class="close" type="button" data-dismiss="modal" aria-label="Close"
                (click)="modalDeleteClose()">
          <span class="font-weight-light" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p class="text-center fs-20 fw-600">Are you sure?</p>
        <p class="text-muted fs-13 pl-3 pr-3 text-center">Do you really want to delete {{delCount==1 ? 'this record' : 'these records'}}? This process can not be undone.</p>
      </div>
      <div class="modal-delete-footer">
        <button class="btn btn-sm mr-2 modal-delete-footer-cancel" type="button" data-dismiss="modal" (click)="modalDeleteClose()">Cancel</button>
        <button class="btn btn-danger btn-sm" type="button" (click)="deleteItem(delId,delType,delType2,delBulkArray)">Delete</button>
      </div>
    </div>
  </div>
</div>
